import React from "react";
import Dynamiclabel from "./dynamic_label";

export default function DynamicLabelGroup({
  factupdate,
  language,
  locale,
  localeKey,
  data,
  groupHeader,
  groupHeaderIcon,
  wrapClassname,
}) {
  const rawData = JSON.parse(data);
  return (
    <>
      {groupHeader ? (
        <div className={`col col-12 col-sm-6 pb-3 ${wrapClassname}`}>
          <div className="content-box-header">
            <img
              src={groupHeaderIcon}
              alt={factupdate ? language[locale]["impact_group_id"] : `-`}
              title={factupdate ? language[locale]["impact_group_id"] : `-`}
            />
            <h4>{factupdate ? language[locale]["impact_group_id"] : `-`}</h4>
            <div className="full-detail-job-des mx-1">
              {rawData && rawData.length > 0
                ? rawData.map((datas, index) => {
                    const objKey = Object.keys(datas)[0];
                    if (
                      datas[objKey]?.label_group === localeKey &&
                      datas[objKey]?.input !== undefined
                    ) {
                      return (
                        <Dynamiclabel
                          key={`impact_dynamic_labelgroup_index${index}`}
                          factupdate={factupdate}
                          language={language}
                          locale={locale}
                          keyData={objKey}
                          data={datas[objKey].input}
                        ></Dynamiclabel>
                      );
                    }
                  })
                : null}
            </div>
          </div>
        </div>
      ) : (
        <>
          {wrapClassname ? (
            <div className={`${wrapClassname}`}>
              {RenderDynamic(rawData, factupdate, language, locale)}
            </div>
          ) : (
            RenderDynamic(rawData, factupdate, language, locale)
          )}
        </>
      )}
    </>
  );
}
function RenderDynamic(rawData, factupdate, language, locale, wrapClassname) {
  return (
    <>
      {rawData && rawData.length > 0
        ? rawData.map((datas, index) => {
            const objKey = Object.keys(datas)[0];
            if (datas[objKey].input !== undefined) {
              return (
                <div
                  className={wrapClassname}
                  key={`impact_dynamic_labelgroup_index${index}`}
                >
                  <Dynamiclabel
                    factupdate={factupdate}
                    language={language}
                    locale={locale}
                    keyData={objKey}
                    data={datas[objKey].input}
                  ></Dynamiclabel>
                </div>
              );
            }
          })
        : null}
    </>
  );
}
